/** Providers may reject with plain objects or wrap the original JSON-RPC error. */
function errorObjects(error: unknown): Record<string, unknown>[] {
  const queue = [error], seen = new Set<unknown>(), result: Record<string, unknown>[] = [];
  while (queue.length && seen.size < 12) {
    const value = queue.shift();
    if (!value || typeof value !== "object" || seen.has(value)) continue;
    seen.add(value);
    const item = value as Record<string, unknown>;
    result.push(item);
    queue.push(item.cause, item.data, item.originalError, item.error);
  }
  return result;
}

export function walletErrorCode(error: unknown): number | undefined {
  const codes = errorObjects(error).map(item => item.code).filter((code): code is number => typeof code === "number");
  // Internal/server errors can wrap a more specific wallet error.
  return codes.find(code => code !== -32603 && code !== -32000) ?? codes[0];
}

export function walletErrorMessage(error: unknown, fallback: string): string {
  const message = errorObjects(error).find(item => typeof item.message === "string" && item.message.trim())?.message;
  return typeof message === "string" ? message.trim() : fallback;
}
